<div class="hardware-list">
  <icc-select-box
    [title]="selectedType?.name"
    [description]="selectedType?.description"
    [imageUrl]="selectedTypeImg"
  ></icc-select-box>

  @if (colors.length > 0) {
    <mat-card appearance="outlined" class="mat-elevation-2">
      @for (colorGroup of colors; track colorGroup) {
        <div>
          <p>
            {{('DOOR|Wybierz kolor:' | translate) }}
          </p>
          <icc-list
            [items]="colorGroup.colors"
            itemTemplate="itemColor"
            [scrollable]="false"
            [selected]="selectColorId"
            (select)="selectColor($event, colorGroup.colorSource)">
          </icc-list>
        </div>
      }
    </mat-card>
  }
</div>

<div class="selected-summary mat-elevation-z4">
  <img [src]="selectedTypeImg" defaultImg>
  <p>{{ selectedType?.name }} {{getColorName()}}</p>
  <button
    mat-raised-button (click)="save()" color="primary"
    >
    {{ 'INTERFACE|Wybierz' | translate}}
  </button>
</div>
